export enum SheetFilterType {
    PERSONAL = 'PERSONAL',
    SHARED = 'SHARED',
}
